// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
export default '\nvoid clipAntimeridian() {}';
